<template>
  <transition name="router-anim">
    <div class="kit-gen">
      <section class="info-block-wrapper search">
        <div class="custom-alert">
          <strong>From this page, users can generate an encrypted Kit ID, which is used to create a QR code for kit activation.
          </strong>
        </div>
        <div class="title search">
          <span>Generate Kit URL</span>
        </div>
        <div class="input-div-wrap">
          <div class="label-wrap">
            <label>Enter the starting kit ID</label>
          </div>
          <div class="input-wrap">
            <input
              v-mask="'XX'"
              v-validate="'required'"
              name="input0"
              type="text"
              class="input-item"
              :value="input0"
              @input="checkInput"
              maxlength="2"
            />
            <input
              v-mask="'XX'"
              v-validate="'required'"
              name="input1"
              type="text"
              class="input-item"
              :value="input1"
              @input="checkInput"
              maxlength="2"
            />
            <input
              v-mask="'XXX'"
              v-validate="'required'"
              name="input2"
              type="text"
              class="input-item"
              :value="input2"
              @input="checkInput"
              maxlength="3"
            />
            <input
              v-mask="'XXXX'"
              v-validate="'required'"
              name="input3"
              type="text"
              class="input-item"
              :value="input3"
              @input="checkInput"
              maxlength="4"
            />
          </div>
          <div class="label-wrap">
            <label>Enter the number of kit IDs to generate</label>
          </div>
          <div class="input-wrap">
            <input
              v-validate="'required'"
              type="text"
              class="input-item"
              name="limit"
              v-model="limit"
            />
          </div>
          <div class="label-wrap" v-if="isComplete">
            <p class="label-wrap">
              Starting Kit: {{ this.convertKitId(this.startingKit) }}
            </p>
            <p class="label-wrap">
              Ending Kit: {{ this.convertKitId(this.endingKit) }}
            </p>
          </div>
          <div id="proceed-button-wrap">
            <button
              class="btn btn-test search"
              @click.prevent="$validator.validateAll()"
              @click="generateKitUrlsCsv"
              :disabled="!isComplete"
            >
              Proceed
            </button>
          </div>
        </div>
      </section>
    </div>
  </transition>
</template>

<script>
import { mapActions } from "vuex";
import { parseAndConvertKitId } from "../../mixins/parseAndConvertKitId";
import { mapGetters } from "vuex";
import Vue from 'vue' 
import axios from "axios";
import VueQRCodeComponent from 'vue-qrcode-component'
Vue.component('qr-code', VueQRCodeComponent)

export default {
  name: "KitUrlGenerator",
  mixins: [parseAndConvertKitId],
  data() {
    return {
      input0: '',
      input1: '',
      input2: '',
      input3: '',
      startingKit: '',
      endingKit: '',
      inputLimit: {
        input0: 2,
        input1: 2,
        input2: 3,
        input3: 4
      },
      limit: null,
      disabled: false,
      isComplete: false,
      api_url: process.env.VUE_APP_API_URL
    };
  },
  computed: {
    ...mapGetters(["serverValidation"]),
  },
  watch: {
    startingKit() {
      this.checkKitIdAndLimit();
    },
    limit() {
      this.checkKitIdAndLimit();
    }
  },
  methods: {
    checkInput(e) {
      e.target.value = e.target.value.toUpperCase();
      this[e.target.name] = e.target.value;
      
      if(e.target.value.length == this.inputLimit[e.target.name]) {
        e.target.nextElementSibling && e.target.nextElementSibling.focus();
      }

      if(e.target.value !== '' && e.target.value.length > this.inputLimit[e.target.name]) {
        if(e.target.nextElementSibling) {
          var str = e.target.value.substring(0, this.inputLimit[e.target.name]);
          var newStr = e.target.value.split("").pop();
          e.target.nextElementSibling && e.target.nextElementSibling.focus();
          e.target.value = str;
          e.target.nextElementSibling.value = newStr;
        }else{
          e.target.value = e.target.value.substring(0, this.inputLimit[e.target.name]);
        }
      }

      if (e.target.value === "") {
        e.target.previousElementSibling &&
        e.target.previousElementSibling.focus();
      }

      this.startingKit = this.input0 + this.input1 + this.input2 + this.input3;
    },
    checkKitIdAndLimit() {
      if(this.startingKit.length == 11 && this.limit !== null && this.limit > 0) {
        this.isComplete = true;
        var lastId = String(Number(this.input2 + this.input3) + Number(this.limit) - 1);
        this.endingKit = this.input0 + this.input1 + lastId.padStart(7, '0');
      }else {
        this.isComplete = false;
      }
    },
    async generateKitUrlsCsv() {
      const data = {
        startingKit: this.convertKitId(this.startingKit)
      };

      await axios({
        url: `${this.api_url}/v1/admin/generateKitUrls/${data.startingKit}/${this.limit}`,
        method: "GET",
        responseType: "blob"
      })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `KitQRCodeDetails.csv`
        );
        document.getElementById("proceed-button-wrap").appendChild(link);
        link.click();
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../styles/colors";

.description-modal{
  text-align: start;
  position: absolute;
  top: 7px;
  left: 5px;
}

.title {
  color: #b3b3b3;
  font-size: 12px;
  font-family: TTNormsMedium, sans-serif;
}
.input-item {
  width: 9.2%;
  min-width: 60px;
  height: 45px;
  padding: 13px 0;
  margin: 0 4px;
  text-align: center;
  border: 1px solid #ccc;
  font-size: 18px;
  border-radius: 5px;
  font-family: TTNormsLight, sans-serif;
}
.input-item.error {
  border: 1px solid $red;
}
.input-item::-webkit-outer-spin-button,
.input-item::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}
.btn {
  align-items: center;
  justify-content: center;
  outline: none;
  border: 1px solid transparent;
  font-size: 12px;
  font-family: TTNormsLight, sans-serif;
  padding: 6px 15px 6px 15px;
  height: 30px;
  margin: 0 0 0 13px;
  cursor: pointer;
  border-radius: 5px;
}
.btn.search {
  height: 35px;
  min-width: 440px;
  margin: 0px;
}
.btn-test {
  background-color: #005eb8;
  color: #fff;
  max-width: 160px;
  width: 100%;
}
.title {
  color: #1052b2;
  padding: 20px 0 0 0;
  font-size: 16px;
  font-family: TTNormsMedium, sans-serif;
  margin: 0 0 30px 0;
  display: flex;
  position: relative;
  justify-content: space-between;
}
.title.search {
  font-size: 20px;
  margin: 0 0 20px 0;
  display: inherit;
  padding: 0px;
}
.info-block-wrapper {
  width: 100%;
  min-height: 200px;
  box-sizing: border-box;
  padding: 40px 30px;
  display: block;
  justify-content: space-between;
  background-color: $white;
  border-radius: 15px;
  box-shadow: 0 3px 15px -9px $boxShadow;
  font-family: TTNormsRegular, sans-serif;
  color: $gray;
  margin: 10px 0;
  position: relative;
}
.info-block-wrapper.search {
  text-align: center;
}
.input {
  width: 440px;
  padding: 12px 30px;
  border-radius: 10px;
  border: 1px solid #c5c5c5;
  color: $gray;
  font-size: 16px;
  text-align: center;
  text-transform: uppercase;
  outline: none;
  font-family: TTNormsMedium, sans-serif;
}
.input::placeholder {
  color: $lightGray;
  font-size: 16px;
  text-align: center;
  text-transform: none;
  font-family: TTNormsMedium, sans-serif;
}
.input-wrap {
  margin-bottom: 15px;
  position: relative;
}
.input.invalid {
  border: 1px solid $red;
}
.btn:disabled {
  cursor: default;
  opacity: 0.5;
}
.label-wrap {
  margin: 10px 0px;
}
.kit-gen{
  margin-top: 50px;
}
.custom-alert {
  text-align: start;
  background-color: #d4edda;
  color: #155724;
  padding: 15px;
  border-radius: 5px;
  border: 1px solid #c3e6cb;
  font-family: TTNormsLight, sans-serif;
  margin-bottom: 20px;
}
</style>
